import { dismiss, useToasts } from '../lib/toast.js';
import { useT } from '../i18n/index.js';

export function Toasts() {
  const toasts = useToasts();
  const t = useT();
  if (!toasts.length) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-16 z-50 flex flex-col items-center gap-2 px-4 md:bottom-4">
      {toasts.map((x) => (
        <div
          key={x.id}
          role="status"
          className={`pointer-events-auto flex max-w-xl items-center gap-3 rounded-xl border px-4 py-2.5 text-sm shadow-xl ${x.kind === 'error' ? 'border-danger bg-danger-soft text-danger' : 'border-line bg-paper text-ink'}`}
        >
          <span className="flex-1">{x.text}</span>
          {x.actions?.map((a) => (
            <button
              key={a.label}
              type="button"
              className="btn"
              onClick={() => {
                a.run();
                dismiss(x.id);
              }}
            >
              {a.label}
            </button>
          ))}
          <button type="button" className="text-muted hover:text-ink" onClick={() => dismiss(x.id)} aria-label={t('toast.dismiss')}>
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
